import { useMutation } from 'react-query';

import { removeReportComment } from 'api/endPoints/removeReportComment';

export const useMutationDeleteReportComment = () => {
    return useMutation<string, QueryError, number>((id) => removeReportComment(id));
};
